import React from "react";
import {
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaPinterest,
  FaYoutube,
} from "react-icons/fa";

const Footer = () => {
  return (
    <div className="w-full bg-gray-100 py-16">
      <div className="max-w-[1240px] mx-auto flex flex-col px-4">
        <div className="sm:flex text-center justify-between items-center">
          <h1>Trav'frica</h1>
          <div className="flex justify-between w-full sm:max-w-[280px] my-4">
            <FaFacebook className="icon" />
            <FaTwitter className="icon" />
            <FaYoutube className="icon" />
            <FaPinterest className="icon" />
            <FaInstagram className="icon" />
          </div>
        </div>
        <div className="flex flex-col sm:flex-row sm:justify-between">
          <ul className="lg:flex text-[#c2410c] font-bold sm:justify-start">
            <li>About</li>
            <li>Careers</li>
            <li>Legal Information</li>
            <li>Privacy Policy</li>
            <li>Cookies</li>
            <li>Accessibility</li>
          </ul>
          <ul className="text-left lg:flex font-bold sm:justify-start sm:mt-4 lg:mt-0">
            <li>Home</li>
            <li>Destinations</li>
            <li>Travel</li>
            <li>Book</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Footer;
